var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tabs"},_vm._l((_vm.tabs),function(item,index){return _c('li',{key:index,staticClass:"item",class:{ active: _vm.activeTab === index, small: _vm.small },on:{"click":function($event){return _vm.changeTabHandler(index)}}},[_vm._v("\n        "+_vm._s(item.title)+"\n   ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }